import PropTypes from "prop-types";
import { memo } from "react";
import { OFFER_TYPES } from "app/constants";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { FormattedDate, FormattedMessage, FormattedPlural } from "react-intl";
import get from "lodash/get";
import TransportationPictoContainer from "app/pages/.shared/TransportationPicto/TransportationPictoContainer";
import "./SingleOfferInput.scss";
import PopoverInfo from "app/pages/.shared/Popover/PopoverInfo";
import MilesEarnedContainer from "app/pages/.shared/MilesEarned/MilesEarnedContainer";
import { ICON_SIZES } from "app/constants";

const SingleOfferInput = ({ offer }) => {
	const nightCount = get(offer, "pricing.minPrice.n");
	const offerType = get(offer, "pricing.type");
	const price = get(offer, "pricing.minPrice.p");
	const publicPrice = get(offer, "pricing.minPrice.pp");
	const departureDate = get(offer, "pricing.minPrice.dd");
	const departureCity = get(offer, "pricing.minPrice.dc");

	const priceIsAvailable = !isNaN(price);
	const isOfferWithFlight = offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION;

	// eslint-disable-next-line react/no-multi-comp
	const nightCountWording = (...chunks) => (
		<div className="single-offer-input__night-count">
			{chunks}{" "}
			<PopoverInfo
				popOverButtonClassName="single-offer-input__tooltip"
				popOverContent={
					<div>
						{isOfferWithFlight ? (
							<FormattedMessage
								id="product.page.cheapest.fa.offer.info"
								values={{
									duration: nightCount,
									departureCity,
									departureDate: (
										<FormattedDate
											timeZone="UTC"
											day="2-digit"
											month="2-digit"
											year="numeric"
											value={departureDate}
										/>
									),
								}}
							/>
						) : (
							<FormattedMessage
								id="product.page.cheapest.ao.offer.info"
								values={{
									duration: nightCount,
									departureDate: (
										<FormattedDate
											timeZone="UTC"
											day="2-digit"
											month="2-digit"
											year="numeric"
											value={departureDate}
										/>
									),
								}}
							/>
						)}
					</div>
				}
			/>
		</div>
	);
	const nightCountWordingParameters = { count: nightCount };

	return (
		<div className="single-offer-input">
			<div className="single-offer-input__label">
				{get(offer, "pricing.label")}
				{offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
					<TransportationPictoContainer size={ICON_SIZES.XS} />
				)}
			</div>

			{price > 0 && (
				<div className="single-offer-input__price">
					<AmountContainer
						amount={price}
						prefix={<FormattedMessage id="offer.per.person.from.label" />}
						suffix={
							<FormattedMessage id="general.amount.per.person.suffix.label.short" />
						}
					/>
				</div>
			)}

			{offerType === OFFER_TYPES.ACCOMODATION_ONLY && (
				<div className="single-offer-input__public-price">
					{publicPrice && (
						<AmountContainer
							amount={publicPrice}
							prefix={<FormattedMessage id="general.instead.of.price" />}
							suffix={
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							}
						/>
					)}
				</div>
			)}
			{priceIsAvailable && (
				<FormattedPlural
					value={nightCount}
					one={
						<FormattedMessage
							id="general.nights.count.singular"
							values={nightCountWordingParameters}
						>
							{nightCountWording}
						</FormattedMessage>
					}
					other={
						<FormattedMessage
							id="general.nights.count"
							values={nightCountWordingParameters}
						>
							{nightCountWording}
						</FormattedMessage>
					}
				/>
			)}
			<MilesEarnedContainer price={price} />
		</div>
	);
};

SingleOfferInput.propTypes = {
	offer: PropTypes.object,
};

export default memo(SingleOfferInput);
